import { isNative } from '../../../utils/jweb';

export async function shouldDisplayNativeAuthSpecification(): Promise<boolean> {
  return isNative();
}
